<template>
  <div>
    <v-speed-dial :absolute="!$vuetify.breakpoint.mobile" right>
      <template v-slot:activator>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              fab
              v-bind="attrs"
              v-on="on"
              @click="toggleHelpText()"
              :small="$vuetify.breakpoint.mobile"
            >
              <v-icon>
                mdi-information-outline
              </v-icon>
            </v-btn>
          </template>
          <span>More information</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              fab
              v-bind="attrs"
              v-on="on"
              @click="toggleAboutText()"
              :small="$vuetify.breakpoint.mobile"
            >
              <v-icon>
                mdi-account-question
              </v-icon>
            </v-btn>
          </template>
          <span>About this space</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              fab
              v-bind="attrs"
              v-on="on"
              @click="navigateToProjectPage()"
              :small="$vuetify.breakpoint.mobile"
            >
              <v-icon>
                mdi-exit-to-app
              </v-icon>
            </v-btn>
          </template>
          <span>Back to project page</span>
        </v-tooltip>
      </template>
    </v-speed-dial>

    <v-dialog
      :value="showHelpText"
      width="50%"
      @click:outside="toggleHelpText()"
      @keydown="toggleHelpText()"
    >
      <v-card
        style="min-height: 50vh; max-height: 70vh; overflow-y: auto;"
        class="text-center"
      >
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            {{ slideTitle }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="toggleHelpText()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-html="helpText" style="padding-top: 2%"> </v-card-text>
      </v-card>
    </v-dialog>

    <!-- <v-dialog
      :value="showReminderModal"
      width="50%"
      @click:outside="showReminderModal = false"
    >
      <v-card
        style="min-height: 50vh; max-height: 70vh; overflow-y: auto;"
        class="text-center"
      >
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            Reminder
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text style="padding-top: 2%">
          <p class="text-justify help">
            Did you review the executive summary prepared by the proposer interested in the SR 316 Express Lanes project
          </p>
          <p class="text-justify help">
            <strong>Remember to submit comments for each summary by July 3, 2021. </strong>
          </p>
        </v-card-text>
        <v-btn @click="showReminderModal = false">OK</v-btn>
      </v-card>
    </v-dialog> -->

    <v-dialog
      :value="showAboutText"
      width="50%"
      @click:outside="toggleAboutText()"
      @keydown="toggleAboutText()"
    >
      <v-card
        style="min-height: 50vh; max-height: 70vh; overflow-y: auto;"
        class="text-center"
      >
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            About This Space
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="toggleAboutText()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-html="aboutText" style="padding-top: 2%"> </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    slideTitle: { type: String, default: "" },
    helpText: { type: String, default: "" },
    aboutText: { type: String, default: "" },
    showHelpText: { type: Boolean, default: true },
    showAboutText: { type: Boolean, default: false },
    showReminderModal: { type: Boolean, defaul: false },
    toggleHelpText: { type: Function },
    toggleAboutText: { type: Function },
    toggleReminderModal: { type: Function },
    reminderText: { type: String, default: "Remember to submit comments for each summary by July 3, 2021. "}
  },
  methods: {
    navigateToProjectPage() {
      window.open('https://transformingsr316-gdot.hub.arcgis.com/', 'a_blank')
    }
  }
};
</script>

<style>
.buttonStyle {
  margin-top: 25%;
}
</style>
